<template>
  <div>
    <div class="banner_cup">
      <product-banner></product-banner>
    </div>
    <div class="pro_info_pot">
      <div class="pro_info_cup">
        <div class="pro-name">
          <span class="pro-name-info">{{productObj.productName}}</span>
        </div>
        <div class="pro_info">
          <el-row :gutter="20">
            <el-col :span="6">
              <!-- 产品图文信息 -->
              <div class="info-info">
                <div class="info_sub_img">
                  <img :src="productObj.productImg" alt="">
                </div>
                <p v-html="productObj.productText"></p>
              </div>
            </el-col>
            <el-col :span="12">
              <p v-html="productObj.productText"></p>
            </el-col>
            <el-col :span="6">
              <!-- 产品所属单位 -->
              <div class="info-owner">
                <div>
                  <img :src="makerObj.path" alt="" height="80" width="180">
                  <h4>{{makerObj.name}}</h4>
                  <div class="highLight">{{makerObj.title}}</div>
                  <div class="maker-info">{{makerObj.summary}}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import productBanner from './productBanner';
import { viewProductByID } from '@/api/frontApi/frontProduct';
import { viewOneMembers } from '@/api/frontApi/frontMembers';
export default {
  data() {
    return {
      productObj: {},
      makerObj: {
        name: '',
        title: '',
        summary: '',
        path: '',
        id: '',
        time: ''
      }
    };
  },
  components: {
    productBanner
  },
  created() {
    let p = this.$route.params.productId;
    this.getProductParams(p);
  },
  methods: {
    getProductParams(proId) {
      viewProductByID({ productId: proId }).then(res => {
        this.productObj = res.data;
        if (res.data.productComid) this.getMakerInfo(res.data.productComid);
      });
    },
    getMakerInfo(mid) {
      viewOneMembers({ orgId: mid }).then(res => {
        this.makerObj.name = res.data.orgName;
        this.makerObj.title = res.data.orgTypeName;
        this.makerObj.summary = res.data.orgText;
        this.makerObj.path = res.data.orgImg;
        this.makerObj.id = res.data.orgId;
        this.makerObj.time = res.data.orgAddTime;
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.banner_cup {
  width: 100%;
}

.pro_info_pot {
  width: 100%;
  min-height: 600px;

  .pro_info_cup {
    width: 80%;
    margin: 0 auto;

    .pro-name {
      height: 60px;
      color: #fff;
      background-color: #909399;
      font-size: 26px;
      padding: 20px 0 0 20px;
      opacity: 0.9;
    }

    .pro_info {
      width: 100%;
      margin: 20px auto 10px;

      .info-info {
        height: 500px;
        padding: 0 10px 0;

        .info_sub_img {
          text-align: center;
        }

        .info_sub_img img {
          max-width: 700px;
        }
      }

      .info-owner {
        max-height: 500px;
        padding: 10px;

        .maker-info {
          margin-top: 10px;
          overflow: hidden;
          max-height: 240px;
          text-overflow: -o-ellipsis-lastline;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/product/productInfo.vue